import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ParaglidingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"paragliding"}/>
}
